import styled, { css } from 'styled-components'
import arrowDown from '../../../../lib/assets/icons/light-arrow-down.svg'
import WarningIcon from '../../../../lib/assets/icons/warning-orange.svg'
import { BREAKPOINT } from '../../constants'

const secondaryText = '#a9a9a9'
const inputFocus = 'solid 1px rgba(46, 95, 98, 0.69)'
const inputBoxShadow = '0 0 4px 0 rgba(0, 0, 0, 0.3)'

export const baseInputStyle = css`
  appearance: none;
  outline: 0;
  color: #000000;
  display: block;
  border: solid 1px white;
  margin-bottom: 16px;
  margin-top: 0;
  padding: 0 15px;
  font-size: 16px;
  height: 45px;
  width: 100%;
  border-radius: 4px;
  box-shadow: ${inputBoxShadow};
  background-color: rgba(255, 255, 255, 0.5);
  box-sizing: border-box;

  &:focus {
    border: ${inputFocus};
  }

  &::placeholder {
    color: ${secondaryText};
  }

  &:disabled {
    background-color: rgba(0, 0, 0, 0.03);
  }

  @media (max-width: ${BREAKPOINT.SMALL}) {
    font-size: 14px;
    padding: 0 10px;
  }
`

export const Form = styled.form`
  width: 435px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;

  h2 {
    font-family: SpaceGrotesk, sans-serif;

    margin-top: 0;
    margin-bottom: 40px;
    font-size: 26px;
    font-weight: 500;
  }

  @media (max-width: ${BREAKPOINT.SMALL}) {
    width: calc(100% - 10px);

    h2 {
      font-size: 24px;
      margin-bottom: 15px;
    }
  }
`

export const Select = styled.select`
    outline: 0;
    color: ${props => props.value === '' ? secondaryText : 'black'};
    display: block;
    border: solid 1px white;
    margin-bottom: 16px;
    margin-top: 0;
    padding: 0 15px;
    font-size: 16px;
    height: 45px;
    width: 100%;
    border-radius: 4px;
    box-shadow: ${inputBoxShadow};
    background-color: rgba(255, 255, 255, 0.5);
    box-sizing: border-box;

    background-image: url(${props => props.error === 'true' ? WarningIcon : arrowDown});

    background-repeat: no-repeat, repeat;
    background-position: right 0.7em top 50%, 0 0;

    appearance: none;

    &:focus {
    border: ${inputFocus};
  }

`

export const ButtonLink = styled.div`
  border: 0;
  font-size: 12px;
  font-weight: 500;
`

export const Input = styled.input`
  ${baseInputStyle}
`

export const InputGroup = styled.div`
  position: relative;
  width: 100%;

  div {
    position: absolute;
    right: 25px;
    top: 15px;
    color: gray;
    cursor: pointer;
  }
`
export const InputRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0;

  div {
    width: 155px;
  }

  div:nth-child(3) {
    width: 95px;
  }

  @media (max-width: ${BREAKPOINT.SMALL}) {
    flex-direction: column;

    div {
      width: 100%;
    }

    div:nth-child(3) {
      width: 100%;
    }
  }
`

export const AddAnotherSpecialty = styled.div`
  color: #2e5f62;
  font-size: 14px;
  border: 0;
  width: 100%;
  margin-bottom: 15px;
  margin-top: -7px;
  cursor: pointer;
`

export const InputContainer = styled.div`
  position: relative;
  width: 100%;

  .onboard-input {
    ${baseInputStyle}
  }
`

export const InputErrorIcon = styled.img.attrs({
  src: WarningIcon
})`
  position: absolute;
  top: 13px;
  right: 14px;
  height: 20px;
  width: 4px;
`

export const EMRSupportText = styled.p`
  font-size: 16px;
  margin-top: -5px;
  margin-bottom: 20px;
  padding-left: 15px;
  line-height: 1.5;
`
